module.exports = __webpack_public_path__ + "img/s7Model1.102f74a8.webp";